import { Box, Button, Flex, Heading, Table, Text } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { GameDataImportDialog } from 'components/sections/admin-portal/server-controls/game-data-import-dialog';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useState } from 'react';

export const DataControls = () => {
  const [dialogImport, setDialogImport] = useState<number>();

  return (
    <ErrorBoundary identifier="DataControls">
      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell width="200px" align="center">
              Actions
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Description</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            {/* actions */}
            <Table.Cell align="center">
              <Button
                size={RADIX.BUTTON.SIZE.SM}
                className="btn-block"
                onClick={() => setDialogImport(Date.now())}
              >
                Import Request
              </Button>
            </Table.Cell>
            {/* description */}
            <Table.Cell>
              <Flex
                p={RADIX.FLEX.PAD.SM}
                direction="column"
                gap={RADIX.FLEX.GAP.SM}
              >
                <Heading size={RADIX.HEADING.SIZE.SM}>
                  Stats API Import Request
                </Heading>

                <Box>
                  <Text wrap="pretty">
                    Opens a form to import Stats API teams, games, and pitches.
                  </Text>
                </Box>
              </Flex>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>

      {dialogImport && (
        <GameDataImportDialog
          key={dialogImport}
          identifier="AdminPortalGameDataImportDialog"
          onClose={() => setDialogImport(undefined)}
        />
      )}
    </ErrorBoundary>
  );
};
